import { redirect } from "react-router";
import { fetchAuthSession } from "./fetchAuthSession";
import { routesMap } from "../../../router/routesMap";

const authenticationGateway = async () => {
  const { isAuthenticated } = await fetchAuthSession();
  if (!isAuthenticated) {
    return redirect(routesMap.login.url());
  }
  return true;
};

export { authenticationGateway };
